export const NavbarData = [
    {
        title: 'LEARNING LIBRARY',
        path: '#LearningLibrary',
        cName: 'nav-text nav-content'
    },
    {
        title: 'SOCIAL COMMUNITIES',
        path: '#SocialCommunities',
        cName: 'nav-text nav-content'
    },
    {
        title: 'COACHING',
        path: '#Coaching',
        cName: 'nav-text nav-content'
    },
]